






























import Vue from "vue";

import { indexModule } from "@/plugins/store-accessors";

export default Vue.extend({
  name: "mtk-menu",
  props: {
    position: String,
    count: { type: Number, default: 0 },
  },
  computed: {
    menu() {
      return indexModule.getMeta?.menu;
    },

    enableNotifications() {
      return this.position !== "footer";
    },
  },
});
